import {AbstractFilterComponent} from "./abstract-filter-component.js";
import noUiSlider from "nouislider";
import numberFormat from "../../utils/number-format.js";
import {FilterLabel} from "./components/label.js";

export class FilterPrice extends AbstractFilterComponent {

	static selector = '.js-filter-price';

	slider;

	inputMin;
	inputMax;

	previewMin;
	previewMax;

	format = {
		decimals: 0,
		decimalPoint: '.',
		thousandsSeparator: ',',
	};

	constructor(parent, filter, node) {
		super(parent, filter, node);
		this.init();
	}

	init() {
		let self = this;
		let slider = self.node.querySelector('.js-filter-price__slider');

		if (! slider) {
			throw new Error('Price filter must have defined price range slider! (`.js-filter-price__slider`)');
		}

		self.inputMin = self.node.querySelector('.js-price-min-input');
		self.inputMax = self.node.querySelector('.js-price-max-input');
		self.previewMin = self.node.querySelector('.js-price-min-preview');
		self.previewMax = self.node.querySelector('.js-price-max-preview');

		self.format.decimals = self.node.dataset.formatDecimals || self.format.decimals;
		self.format.decimalPoint = self.node.dataset.formatDecimalPoint || self.format.decimalPoint;
		self.format.thousandsSeparator = self.node.dataset.formatThousandsSeparator || self.format.thousandsSeparator;

		slider.dataset.valueMin = self.inputMin.value;
		slider.dataset.valueMax = self.inputMax.value;

		self.slider = self.initSlider(slider);
	}

	initSlider(slider) {
		let self = this;

		let instance = noUiSlider.create(slider, self.getSliderConfiguration(slider));
		instance.on('update', function(values) {
			self.onSliderUpdateEvent(values);
		});

		instance.on('set', function(values) {
			self.onSliderSetEvent(values);
		});

		return instance;
	}

	getSliderConfiguration(slider) {
		return {
			start: [
				slider.dataset.valueMin,
				slider.dataset.valueMax,
			],
			connect: true,
			cssPrefix: 'c-tk-filter-price-',
			step: slider.dataset.step === undefined ? 1 : parseFloat(slider.dataset.step),
			range: {
				min: parseFloat(slider.dataset.min),
				max: parseFloat(slider.dataset.max),
			}
		};
	}

	onSliderUpdateEvent(values) {
		let self = this;

		let min = parseInt(values[0]);
		let max = parseInt(values[1]);

		if (self.inputMin) {
			self.inputMin.value = min;
		}

		if (self.inputMax) {
			self.inputMax.value = max;
		}

		if (self.previewMin) {
			self.previewMin.innerText = self.formatPreview(min);
		}

		if (self.previewMax) {
			self.previewMax.innerText = self.formatPreview(max);
		}
	}

	onSliderSetEvent() {
		let self = this;

		self.componentStateChanged();
	}

	formatPreview(number) {
		let self = this;

		return numberFormat(number, self.format.decimals, self.format.decimalPoint, self.format.thousandsSeparator);
	}

	updateInputs(_slider, values) {
		let self = this;

		self.setElementPropertyIfExist(_slider.dataset.inputSelectorMin, 'value', values.min);
		self.setElementPropertyIfExist(_slider.dataset.inputSelectorMax, 'value', values.max);
	}

	updatePreviews(_slider, values) {
		let self = this;

		self.setElementPropertyIfExist(_slider.dataset.previewSelectorMin, 'innerText', values.min);
		self.setElementPropertyIfExist(_slider.dataset.previewSelectorMax, 'innerText', values.max);
	}

	setElementPropertyIfExist(_selector, _property, _value) {
		let element = document.querySelector(_selector);
		if (element) {
			element[_property] = _value;
		}
	}

	getLabel() {
		let self = this;

		let values = self.slider.get();

		let min = parseInt(values[0]);
		let max = parseInt(values[1]);

		if (min === self.slider.options.range.min && max === self.slider.options.range.max) {
			return;
		}

		let content = self.node.dataset.labelPattern;
		content = content.replace(/{min}/, self.formatPreview(min));
		content = content.replace(/{max}/, self.formatPreview(max));

		return new FilterLabel(self, content);
	}

	labelDismissed() {
		let self = this;

		self.filter.setForceUpdateMode();
		self.slider.set([self.slider.options.range.min, self.slider.options.range.max]);
	}

	getFormData() {
		let self = this;

		let values = self.slider.get();

		let min = parseInt(values[0]);
		let max = parseInt(values[1]);

		if (min === self.slider.options.range.min && max === self.slider.options.range.max) {
			return;
		}

		let result = {};
		result[self.inputMin.name] = min;
		result[self.inputMax.name] = max;

		return result;
	}
}
